export function target() {
  return ['Services', 'ContentBlock', 'VideoWithText'].includes(this.module);
}

export function migrate() {
  if (this.module === 'VideoWithText') {
    this.module = 'ContentBlock';
    this.name = 'Galeria com texto';
  }

  if (this.data.slides) {
    if (this.data.linkVideo && !this.data.linkVideo.value) {
      delete this.data.linkVideo;
    }

    return;
  }

  if (typeof this.data.linkVideo !== 'undefined') {
    if (this.data.linkVideo) {
      // emptry string or null
      this.data.slides = [
        {
          type: 'video',
          videoSrc: this.data.linkVideo,
        },
      ];
    }

    delete this.data.linkVideo;
  }

  if (this.data.images) {
    this.data.slides = this.data.images.map((image) => ({
      type: 'image',
      ...image,
    }));

    delete this.data.images;
  }
}
